import React, { useEffect, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";
import './styles.css';

function NomeSocial({id, limit, notformat=false, laudo, nome, social}) {

    const name = `${laudo ? laudo + ' - ' : ''} ${social ? `${social}`:`${nome}`}`;

    return (
    <span className={`${notformat ? 'nome-social-notformat' :  'nome-social'}`}>
        <span id={`nome_${id}`}> 
        {!limit && name}
        {limit && name.slice(0, limit)}
		{limit && name.length > limit && '...'}
        </span>
		{limit && name.length > limit && (
			<UncontrolledTooltip placement='top' target={`nome_${id}`}>
				{nome}
			</UncontrolledTooltip>
		 )}
       
        {social && (
            <React.Fragment>
                {' '}
                <i id={`nomesocial_${id}`}
                    className="fas fa-venus-mars" />
                <UncontrolledTooltip
                    placement="top"
                    target={`nomesocial_${id}`}>
                    {nome}
                </UncontrolledTooltip>
            </React.Fragment>
        )}
        </span>
    );
}

export default NomeSocial;


// WEBPACK FOOTER //
// ./src/containers/NomeSocial/index.js